var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-left_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 1h16v16H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-left_svg__a)",
    "data-name": "Scroll Group 53",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    },
    transform: "translate(0 -1)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4,
    d: "M11.672 16.034a.68.68 0 0 0 .061-.88l-.065-.076L5.86 9.234l5.812-5.844a.68.68 0 0 0 .065-.882l-.065-.076a.671.671 0 0 0-.877-.066l-.076.068-6.286 6.321a.68.68 0 0 0-.068.879l.068.079 6.286 6.321a.671.671 0 0 0 .953 0Z",
    "data-name": "Path 18948"
  }))));
};
export default SvgArrowLeft;